import { type ChangeEvent, memo } from 'react'
import { Dialog, DialogContent, DialogActions, TextField } from '@mui/material'
import { Button } from '@ds/components'
import { SONG_ACTION_BUTTONS_STRINGS } from '../strings'

interface OtherReasonDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  reason: string
  onReasonChange: (value: string) => void
}

export const OtherReasonDialog = memo(
  ({ open, onClose, onConfirm, reason, onReasonChange }: OtherReasonDialogProps) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label={SONG_ACTION_BUTTONS_STRINGS.reason}
          fullWidth
          multiline
          rows={4}
          variant="outlined"
          value={reason}
          onChange={(e: ChangeEvent<HTMLInputElement>) => onReasonChange(e.target.value)}
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{SONG_ACTION_BUTTONS_STRINGS.cancel}</Button>
        <Button onClick={onConfirm} variant="contained" disabled={!reason.trim()}>
          {SONG_ACTION_BUTTONS_STRINGS.submit}
        </Button>
      </DialogActions>
    </Dialog>
  ),
)
